import Jsona from "jsona";
import qs from "qs";
import axios from "axios";

const jsona = new Jsona();
const url = process.env.VUE_APP_API_BASE_URL;
const includes = [
  "items",
  "items.storable",
  "items.unitOfMeasureUnit",
  "items.orderItem",
  "internalOrder",
  "sourceEstablishment",
  "sourceEstablishment.warehouse",
  "destinationEstablishment",
  "submittedBy",
  "acceptedBy",
  "canceledBy",
];
const resource = "establishment-internal-invoices";

export default {
  list({ filter = {}, include = [], sort = "-created_at", page = { number: 1, size: 25 } } = {}) {
    const params = {
      include: include.length ? include : includes.join(","),
      sort,
      page,
      filter,
    };

    const options = {
      params,
      paramsSerializer: function (params) {
        return qs.stringify(params, { encode: false });
      },
    };

    return axios.get(`${url}/${resource}`, options).then((response) => ({
      list: jsona.deserialize(response.data),
      meta: response.data.meta,
    }));
  },

  get({ id, include = [] }) {
    const params = {
      include: include.length ? include : includes.join(","),
    };
    const options = {
      params,
      paramsSerializer: function (params) {
        return qs.stringify(params, { encode: false });
      },
    };
    return axios
      .get(`${url}/${resource}/${id}`, options)
      .then((response) => jsona.deserialize(response.data));
  },

  add({ data, include = [] }) {
    const payload = jsona.serialize({
      stuff: data,
      includeNames: null,
    });

    const params = {
      include: include.length ? include : includes.join(","),
    };

    return axios
      .post(`${url}/${resource}?${qs.stringify(params, { encode: false })}`, payload, {
        headers: {
          Accept: "application/vnd.api+json",
          "Content-Type": "application/vnd.api+json",
        },
      })
      .then((response) => jsona.deserialize(response.data));
  },

  update({ data, include = [] }) {
    const payload = jsona.serialize({
      stuff: data,
      includeNames: [],
    });

    const params = {
      include: include.length ? include : includes.join(","),
    };

    return axios
      .patch(`${url}/${resource}/${data.id}?${qs.stringify(params, { encode: false })}`, payload, {
        headers: {
          Accept: "application/vnd.api+json",
          "Content-Type": "application/vnd.api+json",
        },
      })
      .then((response) => jsona.deserialize(response.data));
  },

  destroy({ id }) {
    return axios.delete(`${url}/${resource}/${id}`);
  },

  validate({ id, include = [] }) {
    const params = { include: include.length ? include : includes.join(",") };
    return axios
      .get(`${url}/${resource}/${id}/validate?${qs.stringify(params, { encode: false })}`)
      .then((response) => jsona.deserialize(response.data));
  },

  accept({ id, include = [] }) {
    const params = { include: include.length ? include : includes.join(",") };
    return axios
      .get(`${url}/${resource}/${id}/accept?${qs.stringify(params, { encode: false })}`)
      .then((response) => jsona.deserialize(response.data));
  },

  reject({ id, include = [] }) {
    const params = { include: include.length ? include : includes.join(",") };
    return axios
      .get(`${url}/${resource}/${id}/reject?${qs.stringify(params, { encode: false })}`)
      .then((response) => jsona.deserialize(response.data));
  },

  /**
   * Annuler une facture interne : c'est la contestation. Une réception conforme
   * est acceptée sans personne, l'annulation est donc le seul moyen, pour l'une
   * ou l'autre des deux écoles, de revenir dessus. Le motif est obligatoire et
   * l'autre école en est avertie.
   *
   * Ces routes vivent dans le groupe JsonApi::register : son middleware
   * NegotiateContent refuse un corps de requête qui n'est pas annoncé comme
   * JSON:API, avec un 415.
   */
  cancel({ id, reasonCode, reason = null, include = [] }) {
    const params = { include: include.length ? include : includes.join(",") };
    return axios
      .post(
        `${url}/${resource}/${id}/cancel?${qs.stringify(params, { encode: false })}`,
        { reason_code: reasonCode, reason },
        {
          headers: {
            Accept: "application/vnd.api+json",
            "Content-Type": "application/vnd.api+json",
          },
        }
      )
      .then((response) => jsona.deserialize(response.data));
  },

  print({ id }) {
    const options = {
      headers: {},
      responseType: "blob",
    };
    return axios.get(`${url}/${resource}/${id}/print`, options);
  },

  revertToDraft({ id, include = [] }) {
    const params = { include: include.length ? include : includes.join(",") };
    return axios
      .get(`${url}/${resource}/${id}/revert-to-draft?${qs.stringify(params, { encode: false })}`)
      .then((response) => jsona.deserialize(response.data));
  },
};
